
export const VorlagenQuery = `
query VorlagenQuery {
  vorlagenEntries {
    ... on vorlage_Entry {
      id
      title
      guteLeistung
      sehrGuteLeistung
      befriedigendeLeistung
      beurteilungskategorie {
          id
          title
      }
    }
  }
}
`;

export const ZeugnisMutation = `
mutation MyMutation(
  $id: ID,
  $vorname: String,
  $nachname: String,
  $freierText: String,
  $erstelltesZeugnis: String,
  $sortOrder: [QueryArgument],
  $gespeicherteOptionen: [gespeicherteOptionen_MatrixEntryContainerInput],
  $geburtsdatum: DateTime,
  $heimatort: String,
  $vorgesetzter: [Int],
  $hrVerantwortlicher: [Int],
  $hoehererVorgesetzter: [Int],
  $aktuellerSchritt: String,
  $authorId: ID,
  $geschlecht: String,
  $nachrichten: [nachrichten_MatrixEntryContainerInput],
  $nachrichtenSortOrder: [QueryArgument],
  $zeugnisart: String,
  $pensum: Number,
  $funktion: [Int],
  $bereich: [Int],
  $abteilung: [Int],
  $team: [Int],
  $abschlussgrund: [Int],
  $andererAbschlussgrund: String,
  $anstellungSeit: DateTime,
  $anstellungBis: DateTime,
  $angepassterEinleittext: String
) {
    save_zeugnisse_zeugnis_Entry(
      gespeicherteOptionen: {entries: $gespeicherteOptionen, sortOrder: $sortOrder}
      vorname: $vorname
      nachname: $nachname
      geschlecht: $geschlecht
      id: $id
      freierText: $freierText
      erstelltesZeugnis: $erstelltesZeugnis
      heimatort: $heimatort
      pensum: $pensum
      geburtsdatum: $geburtsdatum
      vorgesetzter: $vorgesetzter
      hrVerantwortlicher: $hrVerantwortlicher
      hoehererVorgesetzter: $hoehererVorgesetzter
      aktuellerSchritt: $aktuellerSchritt
      authorId: $authorId
      nachrichten: {entries: $nachrichten, sortOrder: $nachrichtenSortOrder}
      zeugnisart: $zeugnisart,
      funktion: $funktion,
      bereich: $bereich,
      abteilung: $abteilung,
      team: $team,
      abschlussgrund: $abschlussgrund,
      andererAbschlussgrund: $andererAbschlussgrund,
      anstellungSeit: $anstellungSeit,
      anstellungBis: $anstellungBis,
      angepassterEinleittext: $angepassterEinleittext
    ) {
      id
      uid
      slug
      nachname
      vorname
      zeugnisart
      geschlecht
      heimatort
      pensum
      geburtsdatum
      anstellungSeit
      anstellungBis
      freierText
      angepassterEinleittext
      vorgesetzter {
        id
        lastName
        email
        firstName
        fullName
        ... on User {
          bezeichnung 
        }
      }
      hrVerantwortlicher {
        id
        lastName
        email
        firstName
        fullName
        ... on User {
          bezeichnung 
        }
      }
      hoehererVorgesetzter {
        id
        lastName
        email
        firstName
        fullName
        ... on User {
          bezeichnung 
        }
      }
      funktion {
        ... on funktion_Entry {
          id
          vorlageText
          title
          funktionBezeichnungText
          beurteilungsvorlagen {
            ... on vorlage_Entry {
              id
              title
              guteLeistung
              sehrGuteLeistung
              befriedigendeLeistung
              beurteilungskategorie {
                  id
                  title
              }
            }
          }
        }
      }
      abschlussgrund {
        ... on abschlussgrund_Entry {
          id
          title
          abschlusstextNeutral
          abschlusstextPositiv
        }
      }
      andererAbschlussgrund
      erstelltesZeugnis
      aktuellerSchritt
      gespeicherteOptionen {
        ... on gespeicherteOptionen_Entry {
          id
          aiGenerationMode
          vorlageText
          gewaehlteOption
          vorlageEintrag {
            id
          }
        }
      }
      nachrichten {
        ... on nachricht_Entry {
          id
          nachrichtText
          autor {
            id
            lastName
            email
            firstName
            fullName
            ... on User {
              bezeichnung 
            }
          }
          zugewiesenePerson {
            id
            lastName
            email
            firstName
            fullName
            ... on User {
              bezeichnung 
            }
          }
          datum
          aktuellerSchritt
        }
      }
      bereich {
        ... on bereich_Entry {
          id
          title
          children {
            ... on abteilung_Entry {
              id
              title
              vorlageText
              children {
                ... on team_Entry {
                  id
                  title
                  vorlageText
                  ort
                }
              }
            }
          }
        }
      }
      abteilung {
        ... on abteilung_Entry {
          id
          title
          vorlageText
          children {
            ... on team_Entry {
              id
              title
              vorlageText
              ort
            }
          }
        }
      }
      team {
        ... on team_Entry {
          id
          vorlageText
          title
          ort
        }
      }
    }
  }
`;


export const ZeugnisQuery = `
query ZeugnisQuery($id: [QueryArgument]) {
    zeugnisseEntries(id: $id) {
      ... on zeugnis_Entry {
        id
        uid
        slug
        nachname
        vorname
        zeugnisart
        geschlecht
        heimatort
        pensum
        geburtsdatum
        anstellungSeit
        anstellungBis
        freierText
        angepassterEinleittext
        vorgesetzter {
          id
          lastName
          email
          firstName
          fullName
          ... on User {
            bezeichnung 
          }
        }
        hrVerantwortlicher {
          id
          lastName
          email
          firstName
          fullName
          ... on User {
            bezeichnung 
          }
        }
        hoehererVorgesetzter {
          id
          lastName
          email
          firstName
          fullName
          ... on User {
            bezeichnung 
          }
        }
        funktion {
          ... on funktion_Entry {
            id
            vorlageText
            title
            funktionBezeichnungText
            beurteilungsvorlagen {
              ... on vorlage_Entry {
                id
                title
                guteLeistung
                sehrGuteLeistung
                befriedigendeLeistung
                beurteilungskategorie {
                    id
                    title
                }
              }
            }
          }
        }
        abschlussgrund {
          ... on abschlussgrund_Entry {
            id
            title
            abschlusstextNeutral
            abschlusstextPositiv
          }
        }
        andererAbschlussgrund
        erstelltesZeugnis
        aktuellerSchritt
        gespeicherteOptionen {
          ... on gespeicherteOptionen_Entry {
            id
            aiGenerationMode
            vorlageText
            gewaehlteOption
            vorlageEintrag {
              id
            }
          }
        }
        nachrichten {
          ... on nachricht_Entry {
            id
            nachrichtText
            autor {
              id
              lastName
              email
              firstName
              fullName
              ... on User {
                bezeichnung 
              }
            }
            zugewiesenePerson {
              id
              lastName
              email
              firstName
              fullName
              ... on User {
                bezeichnung 
              }
            }
            datum
            aktuellerSchritt
          }
        }
        bereich {
          ... on bereich_Entry {
            id
            title
            children {
              ... on abteilung_Entry {
                id
                title
                vorlageText
                children {
                  ... on team_Entry {
                    id
                    title
                    vorlageText
                    ort
                  }
                }
              }
            }
          }
        }
        abteilung {
          ... on abteilung_Entry {
            id
            title
            vorlageText
            children {
              ... on team_Entry {
                id
                title
                vorlageText
                ort
              }
            }
          }
        }
        team {
          ... on team_Entry {
            id
            vorlageText
            title
            ort
          }
        }
      }
    }
  }
`;

export const ZeugnisseQuery = `
query ZeugnisseQuery {
    zeugnisseEntries(orderBy: "dateUpdated ASC"){
      ... on zeugnis_Entry {
        id
        uid
        slug
        dateUpdated
        nachname
        vorname
        zeugnisart
        geschlecht
        heimatort
        geburtsdatum
        anstellungSeit
        anstellungBis
        freierText
        angepassterEinleittext
        vorgesetzter {
          id
          lastName
          email
          firstName
          fullName
          ... on User {
            bezeichnung 
          }
        }
        hrVerantwortlicher {
          id
          lastName
          email
          firstName
          fullName
          ... on User {
            bezeichnung 
          }
        }
        hoehererVorgesetzter {
          id
          lastName
          email
          firstName
          fullName
          ... on User {
            bezeichnung 
          }
        }
        funktion {
          ... on funktion_Entry {
            id
            vorlageText
            title
            funktionBezeichnungText
            beurteilungsvorlagen {
              ... on vorlage_Entry {
                id
                title
                guteLeistung
                sehrGuteLeistung
                befriedigendeLeistung
                beurteilungskategorie {
                    id
                    title
                }
              }
            }
          }
        }
        abschlussgrund {
          ... on abschlussgrund_Entry {
            id
            title
            abschlusstextNeutral
            abschlusstextPositiv
          }
        }
        andererAbschlussgrund
        erstelltesZeugnis
        aktuellerSchritt(label: true)
        gespeicherteOptionen {
          ... on gespeicherteOptionen_Entry {
            id
            aiGenerationMode
            vorlageText
            gewaehlteOption
            vorlageEintrag {
              id
            }
          }
        }
        nachrichten {
          ... on nachricht_Entry {
            id
            nachrichtText
            autor {
              id
              lastName
              email
              firstName
              fullName
              ... on User {
                bezeichnung 
              }
            }
            zugewiesenePerson {
              id
              lastName
              email
              firstName
              fullName
              ... on User {
                bezeichnung 
              }
            }
            datum
            aktuellerSchritt
          }
        }
      }
    }
  }
`;


export const UsersQuery = `
query UsersQuery {
  users {
    id
    lastName
    email
    firstName
    fullName
    ... on User {
      bezeichnung 
    }
  }
}
`;

export const FunktionenQuery = `
query FunktionenQuery {
  funktionenEntries {
    ... on funktion_Entry {
      id
      title
      funktionBezeichnungText
      vorlageText
      beurteilungsvorlagen {
        ... on vorlage_Entry {
          id
          title
          guteLeistung
          sehrGuteLeistung
          befriedigendeLeistung
          beurteilungskategorie {
              id
              title
          }
        }
      }
    }
  }
}
`;


export const AbschlussgruendeQuery = `
query AbschlussgruendeQuery {
  abschlussgruendeEntries {
    ... on abschlussgrund_Entry {
      id
      title
      abschlusstextNeutral
      abschlusstextPositiv
    }
  }
}
`;


export const BereicheQuery = `
query BereicheQuery {
  bereicheEntries(level: 1) {
    ... on bereich_Entry {
      id
      title
      children {
        ... on abteilung_Entry {
          id
          title
          vorlageText
          children {
            ... on team_Entry {
              id
              title
              vorlageText
              ort
            }
          }
        }
      }
    }
  }
}
`;

export const InformationQuery = `
  query InformationQuery {
    entry(section: "information") {
      ... on information_Entry {
        id
        information
      }
    }
  }

`;